<template>
<div class="full-wrapper pannel">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-row class="tab-pane-top">
        <div class="box-wrapper shadow-none">
          <span class="desc-page">{{ selectedNode.label }} WAS 상태 <strong>{{ alive }}</strong></span>
        </div>
      </el-row>
      <el-row>
        <div class="row">
          <el-col :md="12" :lg="12">
            <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>인스턴스명</th>
                      <td>{{ configInfoData.objName }}</td>
                    </tr>
                    <tr>
                      <th>IP</th>
                      <td>{{ configInfoData.ipaddress ? configInfoData.ipaddress : '-' }}</td>
                    </tr>
                    <tr>
                      <th>에이전트 매니저명</th>
                      <td>{{ configInfoData.agentManagerName ? configInfoData.agentManagerName : '-' }}</td>
                    </tr>
                    <tr>
                      <th>에이전트 매니저 IP</th>
                      <td>{{ configInfoData.agentManagerIpaddress ? configInfoData.agentManagerIpaddress : '-' }}</td>
                    </tr>
                    <tr>
                      <th>에이전트 버전</th>
                      <td>{{ configInfoData.version ? configInfoData.version : '-' }}</td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>WAS 버전</th>
                      <td>{{ configInfoData.objProductId ? configInfoData.objProductId : '-' }}</td>
                    </tr>
                    <tr>
                      <th>WAS 종류</th>
                      <td>{{ configInfoData.objtypeName ? configInfoData.objtypeName : '-' }}</td>
                    </tr>
                    <tr>
                      <th>JAVA 버전</th>
                      <td>{{ configInfoData.javeVerInfo ? configInfoData.javeVerInfo : '-' }}</td>
                    </tr>
                    <tr>
                      <th>관리자 (정/부)</th>
                      <td>{{ configInfoData.majorLabel }}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td>{{ configInfoData.minorLabel }}</td>
                    </tr>
                  </table>
                </el-col>
              </div>
              <div slot="perfFooter">
                <span>WAS 기동시각: {{ configInfoData.wakeup ? configInfoData.wakeup : '-' }}</span>
              </div>
            </w-perf-widget>
          </el-col>

          <!-- 이벤트 정보 -->
          <el-col :md="12" :lg="12">
            <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
          </el-col>

          <!-- TPS -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('TPS', ...arguments)" :show-change-btn="false" :eventlevel="tpsData.eventlevel">
              <span slot="perfHeader">TPS</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="tpsViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in tpsData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="tpsData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="tpsViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in tpsData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in tpsData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(tpsData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>

          <!-- 응답시간 -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('RESPONSE', ...arguments)" :show-change-btn="false" :eventlevel="responseData.eventlevel">
              <span slot="perfHeader">응답시간</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="responseViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in responseData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="responseData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="responseViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in responseData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in responseData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(responseData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>

          <!-- JVM 사용률 -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('JVM', ...arguments)" :show-change-btn="false" :eventlevel="jvmData.eventlevel">
              <span slot="perfHeader">JVM 사용률</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="jvmViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in jvmData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="jvmData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="jvmViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in jvmData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in jvmData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(jvmData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>

          <!-- GC 실행시간 -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('GCTIME', ...arguments)" :show-change-btn="false" :eventlevel="gctimeData.eventlevel">
              <span slot="perfHeader">GC 실행시간</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="gctimeViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in gctimeData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="gctimeData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="gctimeViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in gctimeData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in gctimeData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(gctimeData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>

          <!-- 호스트 -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('HOST', ...arguments)" :show-change-btn="false" :eventlevel="hostData.eventlevel">
              <span slot="perfHeader">HOST 성능</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="hostViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in hostData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="hostData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="hostViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in hostData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in hostData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(hostData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>

          <!-- SERVICE -->
          <el-col :md="12" :lg="12">
            <w-perf-widget @change-widget-view="changeWidgetView('SERVICE', ...arguments)" :show-change-btn="false" :eventlevel="serviceData.eventlevel">
              <span slot="perfHeader">서비스</span>
              <!-- BODY -->
              <ul class="event-info-list" v-if="serviceViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in serviceData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="serviceData.backBody" />
              <!-- FOOTER -->
              <ul class="legend list" v-if="serviceViewIndex === 0" slot="perfFooter">
                <w-perf-footer-v-info v-for="data in serviceData.frontFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in serviceData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(serviceData.backBody, data) }" />
              </ul>
            </w-perf-widget>
          </el-col>
        </div>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { clone, isNil, isEmpty as objectIsEmpty } from 'lodash';

import ScrollbarMixin from '@/mixins/scrollbar';
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { getDateToString, getIntervalDatetimeParams } from '@/utils/date';
import { isTrue } from '@/utils/boolean';
import { APM } from '@/constants/summary';

import WasAPI from '@/api/performance/apm/was';
import SummaryAPI from '@/api/performance/summary/summary-info';
import WPerfWidget from '../components/PerfWidget';
import WEventInfoWidget from '../components/EventInfoWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WSummaryLineChart from '../components/SummaryLineChart';

export default {
  name: 'WPerformanceApmSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WSummaryLineChart,
    WEventInfoWidget,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'APM2X',
        managetypeKey: '_',
      },
      configInfoData: {},
      eventInfoData: {},
      tpsViewIndex: 1,
      tpsData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      responseViewIndex: 1,
      responseData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      jvmViewIndex: 1,
      jvmData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      gctimeViewIndex: 1,
      gctimeData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      hostViewIndex: 1,
      hostData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      serviceViewIndex: 1,
      serviceData: {
        frontBody: [],
        backBody: [],
        frontFooter: [],
        backFooter: [],
        eventlevel: null,
      },
      alive: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active() {
      this.loadData();
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    convertValuByUnit,
    getIntervalDatetimeParams,
    /**
     * 요약화면 전체 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (this.active && !objectIsEmpty(this.selectedNode)) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadInstanceAlive();
        this.loadConfInfoView();
        this.loadEventInfo();

        const widgetKeyList = ['TPS', 'RESPONSE', 'JVM', 'GCTIME', 'HOST', 'SERVICE'];
        widgetKeyList.forEach((widgetKey) => {
          const widgetKeyLower = widgetKey.toLowerCase();
          this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
        });
      }
    },
    /**
     * WAS 구성정보 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadConfInfoView() {
      WasAPI.getWasConfigurationInfo({ objId: this.selectedNode.obj.objId })
        .then((response) => {
          const configInfo = response.data.data;
          if (response.data.success && !isNil(configInfo)) {
            let majorLabel = EMPTY_TEXT;
            let minorLabel = EMPTY_TEXT;
            // 관리자(정/부)
            if (!isEmpty(configInfo.majorName)) {
              majorLabel = !isEmpty(configInfo.majorDepartment) ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
            }
            if (!isEmpty(configInfo.minorName)) {
              minorLabel = !isEmpty(configInfo.minorDepartment) ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
            }
            Object.assign(configInfo, { majorLabel, minorLabel });

            // 서버 기동시각
            configInfo.wakeup = isEmpty(configInfo.wakeup) ? EMPTY_TEXT : getDateToString(configInfo.wakeup, 'YYYY-MM-DD HH:mm:ss');
            this.configInfoData = configInfo;
          } else {
            this.configInfoData = {};
          }
        });
    },
    /**
     * WAS의 이벤트 정보 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      SummaryAPI.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        } else {
          this.eventInfoData = {};
        }
      });
    },
    /**
     * 위젯 전환(전면/후면)
     * @param  {[type]} widgetKey [description]
     * @param  {[type]} viewIndex [description]
     * @return {[type]}           [description]
     * @author jda
     */
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    /**
     * 위젯의 전면 데이터 조회
     * @param  {[type]} summaryWidgetKey [description]
     * @return {[type]}           [description]
     * @author jda
     */
    loadFrontData(summaryWidgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey,
        rscInfoList: APM[summaryWidgetKey],
      });
      const widgetLowerKey = summaryWidgetKey.toLowerCase();
      WasAPI.getSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this[`${widgetLowerKey}Data`].frontBody = result.body;
          this[`${widgetLowerKey}Data`].frontFooter = result.footer;
        }
      });
    },
    /**
     * 위젯 후면 데이터 조회
     * @param  {[type]} summaryWidgetKey [description]
     * @return {[type]}                  [description]
     * @author jda
     */
    loadBackData(summaryWidgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey,
        rscInfoList: APM[summaryWidgetKey],
      });
      const widgetLowerKey = summaryWidgetKey.toLowerCase();
      WasAPI.getSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this[`${widgetLowerKey}Data`].backBody = result.body;
          this[`${widgetLowerKey}Data`].backFooter = result.footer;
          this[`${widgetLowerKey}Data`].eventlevel = result.eventlevel;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((data) => {
        const rscInfo = data.rscInfo;
        if (footer.rsckey) {
          return rscInfo.rscKeyName === footer.rscKeyName;
        } else if (rscInfo) {
          return rscInfo.rsctypeId === footer.rsctypeId && rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
    /**
     * WAS의 상태 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadInstanceAlive() {
      WasAPI.getInstanceAlive({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.alive = isTrue(result) ? 'UP' : 'DOWN';
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/apm/index.vue